import React from 'react';
import { DateTime, SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlSectionType } from '../metroline/types';
import { ExternalUrlFormIds } from '../constants';
import { ExternalUrlSection } from '../types';
import { ExternalUrlTemplate } from 'app/area/external-urls-administration/form/components/external-url-template';

export const ExternalUrlDetails: React.FC<ExternalUrlSection> = ({
  externalUrlItem, updateItem, locale, validation, translation, section, getRef, shouldRenderSection
}) => {

  const onDisabledChange = (disabled: Date) => {
    updateItem({ disabled });
  };

  const onExternalUrlTemplateChange = (urlTemplate: string) => {
    updateItem({ urlTemplate });
  };

  const isReadOnly = externalUrlItem?.id === 0;

  return <MetroLineSection<ExternalUrlSectionType>
    section={section}
    sectionType={ExternalUrlSectionType.Details}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlSectionType.Details)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlSectionType.Details}
        validation={undefined}
        info={{ text: translation.details }}
        label={{ visible: true, text: translation.details }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ExternalUrlTemplate
              value={externalUrlItem?.urlTemplate}
              readOnly={isReadOnly}
              onChange={onExternalUrlTemplateChange}
              validation={validation?.[ExternalUrlFormIds.urlTemplate]}
              translation={translation} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <DateTime
              componentId={ExternalUrlFormIds.disabled}
              className="dateTime"
              value={externalUrlItem?.disabled}
              label={translation ? { text: translation.disabled } : undefined}
              readOnly={isReadOnly}
              useTime={false}
              parseDate={parseAsDateUTC}
              createDate={createUTCDate}
              cloneDate={dateToUTC}
              {...createFormatters(locale)}
              locale={locale}
              onChange={onDisabledChange}
              captionWrapper={'form'}
              validation={validation?.[ExternalUrlFormIds.disabled]} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
